import { Role, Permission, CreateRoleDTO } from "@/contracts/auth-api.types";
import { apiRequest } from "./apiClient";

export const roleService = {
  /**
   * Lista todas as roles vinculadas à aplicação ou escopo geral.
   */
  async listRoles(applicationId?: string): Promise<Role[]> {
    const url = applicationId
      ? `/roles?application_id=${encodeURIComponent(applicationId)}`
      : "/roles";
    return await apiRequest<Role[]>(url);
  },

  /**
   * Cria uma nova role no escopo da aplicação.
   */
  async createRole(dto: CreateRoleDTO): Promise<Role> {
    return await apiRequest<Role>("/roles", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dto),
    });
  },

  /**
   * Lista permissões da aplicação ou associadas a uma role específica.
   */
  async listPermissions(roleId?: string, applicationId?: string): Promise<Permission[]> {
    const params = new URLSearchParams();
    if (roleId) params.append("role_id", roleId);
    if (applicationId) params.append("application_id", applicationId);
    const qs = params.toString();
    const url = qs ? `/permissions?${qs}` : "/permissions";
    return await apiRequest<Permission[]>(url);
  },

  /**
   * Associa uma permissão a uma role.
   */
  async addPermissionToRole(roleId: string, permissionId: string): Promise<{ success: boolean }> {
    return await apiRequest<{ success: boolean }>(`/roles/${roleId}/permissions`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ permission_id: permissionId }),
    });
  },

  /**
   * Remove uma permissão associada a uma role.
   */
  async removePermissionFromRole(
    roleId: string,
    permissionId: string,
  ): Promise<{ success: boolean }> {
    return await apiRequest<{ success: boolean }>(`/roles/${roleId}/permissions/${permissionId}`, {
      method: "DELETE",
    });
  },
};
